import { render } from "./stageTitle.vue?vue&type=template&id=0458274e&scoped=true"
import script from "./stageTitle.vue?vue&type=script&lang=js"
export * from "./stageTitle.vue?vue&type=script&lang=js"

import "./stageTitle.vue?vue&type=style&index=0&id=0458274e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0458274e"]])

export default __exports__